import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { decimalEliminate, decimalThree, decimalTwo } from "../../Utils/commonUtil";
import FPS_Trans_Details from '../../fps/FPS_Trans/FPS_Trans_Details';


const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const KeyRegisterAllotDist_data = async (params) => { 
    const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/FpsDetailedTransactions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const AbstractFpsTransDetails = ({ dist_code, date,  heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading); 
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsLoad = useRef(null);  

    
    const handleDistClick = (month, year, dist_code, fps_id) => {
        setRenderContentt(null);
        
        setTimeout(() => {
            setRenderContentt(
                <FPS_Trans_Details month={month} year={year} fps_id={fps_id}  heading={tabHeading}/>
            );
        }, 10);
        };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotDist_data( {dist_code, date});
               
                if (Array.isArray(response_data.detailedTranscationList)) {
                    setReportData(response_data.detailedTranscationList);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [dist_code, date]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsLoad.current) {
            // detailsLoad.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsLoad.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
         }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }
    const totals = reportData.reduce(
        (acc, item) => {
          acc.abstract_total_cards+=  parseFloat(item.abstract_total_cards) || 0;
          acc.avail_trans_today += parseFloat(item.avail_trans_today) || 0;
          acc.total_units += parseFloat(item.total_units) || 0;
          acc.avail_port_cards_today += parseFloat(item.avail_port_cards_today) || 0;
          acc.avail_poff_cards_today += parseFloat(item.avail_poff_cards_today )|| 0;
          acc.avail_online_cards_today += parseFloat(item.avail_online_cards_today) || 0;
          acc.avail_cards_today += parseFloat(item.avail_cards_today) || 0;
          acc.avail_trans += parseFloat(item.avail_trans) || 0;
          acc.avail_port_cards += parseFloat(item.avail_port_cards) || 0;
          acc.avail_poff_cards += parseFloat(item.avail_poff_cards) || 0;
          acc.avail_online_cards += parseFloat(item.avail_online_cards) || 0;
          acc.avail_cards += parseFloat(item.avail_cards) || 0; 
          acc.trans_per += parseFloat( item.trans_per )|| 0;
          acc.poff_trans_per += parseFloat(item.poff_trans_per) || 0;

          return acc;
        },
        {
            abstract_total_cards: 0,
            avail_trans_today: 0,
            avail_port_cards_today: 0,
            avail_poff_cards_today: 0,
            avail_online_cards_today: 0,
            avail_cards_today: 0,
            avail_trans: 0,
            avail_port_cards: 0,
            avail_poff_cards: 0,
            avail_online_cards: 0,
            avail_cards: 0, 
            trans_per: 0,
            poff_trans_per: 0,
         }
      );

       
    return (
        <>
            <br /><br />
            <table align="center" width="90%" border={1}  ref={detailsLoad}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={19}>
                        Detailed Transactions  
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>FPS</th>
                        <th rowSpan={3}>Dealer</th>
                        <th rowSpan={3}>Total<br/>Cards<br/><font style={{color: 'orange'}}>(A)</font></th>
                        <th colSpan={5}>Date :{date}</th>
                        <th colSpan={5}>Current Month</th>
                        <th colSpan={3}>Availed<br/>%</th>
                        <th rowSpan={3}>Partial %<br/>(Against<br/> Availed Cards)<br/><font style={{color: 'orange'}}>(C*100)/E</font></th>
                     </tr>
                     <tr className="tableheader">
                         <th rowSpan={2}>Trans</th>
                        <th colSpan={4}>Availed Cards</th>
                        <th rowSpan={2}>Trans</th>
                        <th colSpan={4}>Availed Cards</th>
                        <th rowSpan={2}>Self<br/>% </th>
                        <th rowSpan={3}>Portability<br/>%</th>
                        <th rowSpan={3}>Total<br/>Availed %<br/><font style={{color: 'orange'}}>(E*100)/A</font></th>
                     </tr>
                     <tr className="tableheader">
                         <th >Portability</th>
                        <th  >Partial<br/>Offline</th>
                        <th  >Online</th>
                        <th  >Total</th>
                        <th  >Portability<br/><font  style={{color: 'orange'}} >(B)</font> </th>
                        <th  >Partial<br/>Offline<br/><font  style={{color: 'orange'}} >(C)</font></th>
                        <th  >Online<br/><font  style={{color: 'orange'}} >(D)</font></th>
                        <th  >Total<br/><font  style={{color: 'orange'}} >(E = C+D)</font></th>
                     </tr>
                </thead>
                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.fps_id}>
                            <td style={{ textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                            <a style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={() => handleDistClick(item.month, item.year, item.dist_code, item.fps_id)}
                                    >
                                {item.fps_id}
                                </a>

                                </td>
                            <td style={{ textAlign: 'left' }}>{item.del_name}</td>
                            <td style={{ textAlign: 'right' }}>{item.abstract_total_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_trans_today}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_port_cards_today}</td>
                            
                            <td style={{ textAlign: 'right' }}>{item.avail_poff_cards_today}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_online_cards_today}</td>
                            
                            <td style={{ textAlign: 'right' }}>{item.avail_cards_today}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_trans}</td>
                            
                            <td style={{ textAlign: 'right' }}>{item.avail_port_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_poff_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_online_cards}</td>
                            <td style={{ textAlign: 'right' }}>{item.avail_cards}</td>
                            
                            <td style={{ textAlign: 'right' }}>{item.self_trans_per}</td>
                            <td style={{ textAlign: 'right' }}>{item.port_trans_per}</td>
                            
                            <td style={{ textAlign: 'right' }}>{item.trans_per}</td>
                            <td style={{ textAlign: 'right' }}>{item.poff_trans_per}</td>
                        </tr>
                    ))}
                    
                </tbody>
                <tr className="tableheader">
              <td colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.abstract_total_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_trans_today}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_port_cards_today}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_poff_cards_today}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_online_cards_today}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_cards_today}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_trans}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_port_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_poff_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_online_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.avail_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ }</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ }</td>

              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{decimalEliminate(totals.avail_cards*100/totals.abstract_total_cards,2)}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{ 
               totals.abstract_total_cards>0 ? decimalEliminate((totals.avail_poff_cards*100/totals.abstract_total_cards),2) : 0
 }
              </td>
            </tr>
            </table>
           
            <br /><br />
            <div id="detailsERR">{renderContentt}</div>
        
        </>
    );
};

export default AbstractFpsTransDetails;
